const textFieldModalCloneEquipModel = {
  name: 'Nombre Nuevo Tipo de Equipo',
  description: 'Descripción del Equipo'
};

export default textFieldModalCloneEquipModel;
